<template>
    <Drawer
        :title="title"
        v-model="isBox"
        width="840"
        :mask-closable="false"
        @on-close="FormReset()"
        class-name="drawer-default"
    >
        <div class="set-scroll-form">
            <Form ref="Forms" :model="Forms" :rules="Rules" label-position="top">
                <Row :gutter="32">
                    <Col span="24">
                        <Card :bordered="false" dis-hover>
                            <template #title><Icon type="md-radio-button-on" class="text-primary" size="16" /> 维保审批</template>
                            <Row :gutter="32">
                                <Col span="24">
                                    <FormItem label="审批结果" prop="status" :rules="[{required: true, type:'number', message: '请选择审批结果', trigger: 'change', transform(value) { return parseInt(value)}}]">
                                        <RadioGroup v-model="Forms.status" type="button" button-style="solid">
                                            <Radio :label="3">审批通过</Radio>
                                            <Radio :label="2">审批未通过</Radio>
                                        </RadioGroup>
                                    </FormItem>
                                </Col>
                                <Col span="24" v-if="Forms.status === 2">
                                    <FormItem label="未通过原因" prop="reject_remark" :rules="[{required: true, message: '请输入未通过原因', trigger: 'blur'}]">
                                        <Input v-model="Forms.reject_remark" type="textarea" :rows="4" clearable placeholder="请输入未通过原因" />
                                    </FormItem>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </Row>
                <Row :gutter="32">
                    <Col span="24">
                        <Card :bordered="false" dis-hover>
                            <template #title><Icon type="md-document" class="text-primary" size="16" /> 维保信息</template>
                            <DescriptionList class="show-description-title" title="" :col="2" layout="vertical">
                                <Description term="零星项目：">
                                    {{detail.project_name}}
                                </Description>
                                <Description term="甲方：">
                                    {{detail.customer_name ?? '-'}}
                                </Description>
                                <Description term="维保标题：">
                                    {{detail.title}}
                                </Description>
                                <Description term="维保类型：">
                                    <Tag>{{detail.type_name}}</Tag>
                                </Description>
                                <Description term="维保金额：">
                                    <Tag color="blue">{{detail.money}}</Tag>
                                </Description>
                                <Description term="负责人：">
                                    {{detail.head_name ?? '-'}}
                                </Description>
                                <Description term="联系人：">
                                    {{detail.contact_name ?? '-'}}
                                </Description>
                                <Description term="联系电话：">
                                    {{detail.contact_mobile ?? '-'}}
                                </Description>
                                <Description term="开始时间：">
                                    {{detail.start_time || '-'}}
                                </Description>
                                <Description term="结束时间：">
                                    {{detail.end_time || '-'}}
                                </Description>
                            </DescriptionList>
                            <DescriptionList class="show-description-title" title="" :col="1" layout="vertical">
                                <Description term="维保说明：">
                                    {{detail.m_desc || '-'}}
                                </Description>
                                <Description term="备注：">
                                    {{detail.remark || '-'}}
                                </Description>
                            </DescriptionList>
                        </Card>
                    </Col>
                </Row>
            </Form>
            <div class="box-drawer-footer">
                <Button class="mr10" @click="FormReset()">取消</Button>
                <Button type="primary" :loading="$store.state.loading" @click="FormSubmit()">确认审批</Button>
            </div>
        </div>
    </Drawer>
</template>

<script>

import {examineMaintain, getMaintainDetail} from "@/apis/dispersed";

export default {
    name: 'DispersedMaintainExamine',
    components: {
    },
    emits: ['trueHandler'],
    data () {
        return {
            title : '维保审批',
            isBox : false,
            detail: {},
            Forms : {
                maintain_id: '',
                status: '',
                reject_remark: ''
            },
            Rules : {}
        }
    },
    methods: {
        /**
         * 功能：详情
         * time: 2026/10/06
         **/
        GetDetail(maintain_id){
            let that = this;
            that.$store.commit('SET_LOADING' , true);
            getMaintainDetail(maintain_id).then(e => {
                that.detail = e.data;
            })
        },
        /**
         * 功能：打开
         * time: 2026/10/06
         **/
        show(maintain_id, title){
            this.isBox = true;
            this.title = (title || '维保记录') + ' - 维保审批';
            if(maintain_id){
                this.Forms.maintain_id = maintain_id;
                this.GetDetail(maintain_id);
            }
        },
        /**
         * 功能：提交
         * time: 2026/10/06
         **/
        FormSubmit(){
            let that = this;
            this.$refs['Forms'].validate((valid) => {
                if (valid) {
                    that.$store.commit('SET_LOADING' , true);
                    examineMaintain(that.Forms).then( e =>{
                        that.$Message.success({ background: true,duration:3, content: e.msg });
                        that.FormReset();
                        that.$emit('trueHandler');
                    })
                }
            })
        },
        /**
         * 功能：重置
         * time: 2026/10/06
         **/
        FormReset(){
            this.isBox = false;
            this.title = '维保审批';
            this.$refs['Forms'] && this.$refs['Forms'].resetFields();
            this.detail = {};
            this.Forms = {
                maintain_id: '',
                status: '',
                reject_remark: ''
            };
        }
    }
}
</script>

<style scoped lang="less" rel="stylesheet/less">

</style>
